import { render, staticRenderFns } from "./ConfirmReset.vue?vue&type=template&id=1d30600a"
import script from "./ConfirmReset.vue?vue&type=script&lang=js"
export * from "./ConfirmReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports